module.exports = __webpack_public_path__ + "static/media/ATOM-BNB.dd16e730.svg";